import { createSlice } from '@reduxjs/toolkit';

import { myProfileLoaded } from './teamProfile';

const initialState = {
  status: 'idle',
  // 'first' stamps the member on Done or Skip; 'replay' never touches the flag.
  mode: null,
  // The automatic start happens once per sign-in, whatever later profile reads say.
  offered: false,
  saving: false,
  error: null,
};

const tourSlice = createSlice({
  name: 'tour',
  initialState,
  reducers: {
    tourReplayed: (state) => {
      state.status = 'running';
      state.mode = 'replay';
      state.saving = false;
      state.error = null;
    },
    completeWalkthroughAction: (state) => {
      state.saving = true;
      state.error = null;
    },
    walkthroughCompleted: (state) => {
      state.status = 'idle';
      state.mode = null;
      state.saving = false;
      state.error = null;
    },
    walkthroughFailed: (state, action) => {
      state.saving = false;
      state.error = action.payload;
    },
    tourEnded: (state) => {
      state.status = 'idle';
      state.mode = null;
      state.saving = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    // Only a null from the server starts it; a missing key means an API without the flag.
    builder.addCase(myProfileLoaded, (state, action) => {
      if (state.offered || action.payload?.walkthrough_completed_at !== null) return;
      state.offered = true;
      state.status = 'running';
      state.mode = 'first';
      state.saving = false;
      state.error = null;
    });
  },
});

export const {
  tourReplayed,
  completeWalkthroughAction,
  walkthroughCompleted,
  walkthroughFailed,
  tourEnded,
} = tourSlice.actions;

export { tourSlice };
